<template>
  <!-- 美容預約服務說明：預約首頁、店家頁、預約頁共用（法律文字不要任意改動） -->
  <section class="booking-disclaimer" aria-label="預約服務說明">
    <h2 class="booking-disclaimer__title">預約服務說明</h2>
    <div class="booking-disclaimer__item">
      <h3 class="booking-disclaimer__label">服務提供說明</h3>
      <p>本平台（JILI）僅提供線上預約媒合與資訊展示服務，各項美容服務均由各合作店家獨立經營並自行提供。本平台不直接參與店家實際服務內容，亦不介入消費者與店家間因服務內容、服務品質、預約異動、退款、退費、損害賠償或其他消費爭議所生之協商與處理，相關權利義務應由消費者與店家雙方自行協調解決。</p>
    </div>
    <div class="booking-disclaimer__item">
      <h3 class="booking-disclaimer__label">預約資料使用</h3>
      <p>為完成預約處理、預約確認、店家聯繫及服務安排，使用者於預約時所提供之姓名、電話及其他必要預約資訊，將提供予該筆預約所屬之店家，供其於預約與服務必要範圍內使用。除依法令規定、主管機關要求，或為處理該筆預約所必要者外，本平台不會將前述資料提供予其他無關第三人或其他未被預約之店家。</p>
    </div>
    <div class="booking-disclaimer__item">
      <h3 class="booking-disclaimer__label">店家管理</h3>
      <p>本平台得依營運管理需要，對違反法令、平台規範、侵害消費者權益，或有其他不當行為之店家，採取下架、停權、終止合作或其他必要處置，以維護平台秩序與消費者使用環境。</p>
    </div>
  </section>
</template>

<script>
export default { name: 'BookingDisclaimer' }
</script>

<style scoped>
.booking-disclaimer {
  margin: 48px auto 80px;
  max-width: 1100px;
  box-sizing: border-box;
  background: #fff8f0;
  border-left: 4px solid #ff6600;
  border-radius: 6px;
  padding: 18px 22px;
  text-align: left;
  color: #555;
}
.booking-disclaimer__title {
  margin: 0 0 12px;
  font-size: 1rem;
  font-weight: 700;
  color: #444;
}
.booking-disclaimer__item + .booking-disclaimer__item {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed #f3d3b8;
}
.booking-disclaimer__label {
  margin: 0 0 4px;
  font-size: 0.875rem;
  font-weight: 700;
  color: #c45200;
}
.booking-disclaimer p {
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.8;
}
@media (max-width: 600px) {
  .booking-disclaimer {
    margin: 36px 16px 72px;
    padding: 14px 16px;
  }
}
</style>
